import React from 'react';

import { CheckboxProps } from '../../interfaces';
import { BooleanField } from './boolean.component';

export function Switch(props: CheckboxProps): JSX.Element {
  return <BooleanField {...props} useSwitch />;
}
